import { z } from 'zod/v4';
import { AttributeInstanceDTO } from './attribute/attribute-instance';

export const CIAttributeDTO = z.object(AttributeInstanceDTO.shape);
export type CIAttribute = z.infer<typeof CIAttributeDTO>;